
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as login6DbUp_45Hrg_FMVyeXHALSCv2gNFi7D1ETVaAscmBybDsMeta } from "/home/les/work/depalop/etmflex/frontend/pages/login.vue?macro=true";
import { default as indexVXLY_452BysBEc8hSz1Ejztqaor9A45CLMd95lffRHAx0Meta } from "/home/les/work/depalop/etmflex/frontend/pages/dd/index.vue?macro=true";
import { default as indexIrTiYQc2LOWmNvug7vKFVxXgGlFfYh0cJjZtNuUBj20Meta } from "/home/les/work/depalop/etmflex/frontend/pages/ip/index.vue?macro=true";
import { default as datakAAKsjFPgM_45sxqr2JIz_45k2t_45VUQlB1QMPMz3iBF5sgYMeta } from "/home/les/work/depalop/etmflex/frontend/pages/report/data.js?macro=true";
import { default as reset_45pass9yPl2xoH5S33jAZuqlcS0VK0_WwE6nc2g6k5jRBZ_pIMeta } from "/home/les/work/depalop/etmflex/frontend/pages/reset-pass.vue?macro=true";
import { default as indexi8RA2_HlsfQsbOo5EqbQjOke3CE8uxI5ZfsH6krvgh4Meta } from "/home/les/work/depalop/etmflex/frontend/pages/site/index.vue?macro=true";
import { default as indexNkr1UqYOJ__45INI7yaiR4830jFt2pnm8d_K0tzR378xkMeta } from "/home/les/work/depalop/etmflex/frontend/pages/task/index.vue?macro=true";
import { default as dataQKQk_45feJyT7BtsO49993P7zZrsRC8MRlKc2M0CuP2hkMeta } from "/home/les/work/depalop/etmflex/frontend/pages/pending/data.js?macro=true";
import { default as dataynQ1fZP8lTy_45DdnayGuaRQcak5gQEtGHU5AGExtecnwMeta } from "/home/les/work/depalop/etmflex/frontend/pages/explorer/data.js?macro=true";
import { default as indexa5Y6lgY0cEnwHLsuwww5SW3FKaQMpupGcFvAQ_zb4yUMeta } from "/home/les/work/depalop/etmflex/frontend/pages/metric/index.vue?macro=true";
import { default as indexa7QbScC04ug0Giyt3PRDXjjeNEjmvT7C5_45qrxX_45_45ZD4Meta } from "/home/les/work/depalop/etmflex/frontend/pages/report/index.vue?macro=true";
import { default as index5bW9f8i8WL9NjzQkxTj_oJicOKPt7xL_2KZeRqDjL6UMeta } from "/home/les/work/depalop/etmflex/frontend/pages/example/index.vue?macro=true";
import { default as configqE5bqKiRdJbqA0EshsXWWuBjUzuJ1gUr2O64JAskVJYMeta } from "/home/les/work/depalop/etmflex/frontend/pages/pending/config.js?macro=true";
import { default as index_45PUBpo4oM8bEhLqOb1tcvVRhw2B9Gu7kcNwWkdgzmhAMeta } from "/home/les/work/depalop/etmflex/frontend/pages/pending/index.vue?macro=true";
import { default as indexDiyew2Nk_45dy14guSWWpRxRxEBs35RviaUXB9ia7GBZQMeta } from "/home/les/work/depalop/etmflex/frontend/pages/profile/index.vue?macro=true";
import { default as index_P8vU9QEYnzpKhLt0xIiBt_YAyJZSk9UhgFE1wZjrzQMeta } from "/home/les/work/depalop/etmflex/frontend/pages/accounts/index.vue?macro=true";
import { default as indexDY4y3EvzQmVL7rt_OAQC295BE_45_45piCeHrRiA2FaQKggMeta } from "/home/les/work/depalop/etmflex/frontend/pages/example2/index.vue?macro=true";
import { default as indexNnqTFBYyuVr_mGILPzuOFDAAXJ8XlcNqWjRV0xeCzdcMeta } from "/home/les/work/depalop/etmflex/frontend/pages/testflex/index.vue?macro=true";
import { default as indexD4_7akdnuxX0q7vzMOGL4U91ePluvmAgZlc27MntjVQMeta } from "/home/les/work/depalop/etmflex/frontend/pages/dashboard/index.vue?macro=true";
import { default as indexRfGroN_V_457BQk_QyJFragDIgtWsPOazF7S1eHKAAf6UMeta } from "/home/les/work/depalop/etmflex/frontend/pages/personnel/index.vue?macro=true";
import { default as index96BwUhs2vEe1rlTEZ5SZZvIF9oCpA18boSvVbo4k_X8Meta } from "/home/les/work/depalop/etmflex/frontend/pages/protocols/index.vue?macro=true";
import { default as config_site5MSn4ZKQUhbb22twqkALYU0IF0eGCT4iJilOupgS7_4Meta } from "/home/les/work/depalop/etmflex/frontend/pages/site/config_site.js?macro=true";
import { default as config_taskX6m13gEg16RObV3upfCdIAryc_Y7S3D5wkv_45kic1lSUMeta } from "/home/les/work/depalop/etmflex/frontend/pages/task/config_task.js?macro=true";
import { default as indexY4CwEHWa5EF0r3EmvG6NcZjNewt2r4hXECanma6V2hQMeta } from "/home/les/work/depalop/etmflex/frontend/pages/permission/index.vue?macro=true";
import { default as indexEsi3u03bT_m9AA868oXkjcTP15IEvztf00bHzLZfshoMeta } from "/home/les/work/depalop/etmflex/frontend/pages/study_role/index.vue?macro=true";
import { default as confirm_45reset_45passHg__1KjK60_dIYwLMowlainlGfzvA4xYEx0gOc258vEMeta } from "/home/les/work/depalop/etmflex/frontend/pages/confirm-reset-pass.vue?macro=true";
import { default as config_treatmentLesejMTDbUZbqXdDqd6gpgAKu4h2zGl_z2gv54E_4GkMeta } from "/home/les/work/depalop/etmflex/frontend/pages/ip/config_treatment.js?macro=true";
import { default as config_logCU4EQsdBMidOS5P3qTh4ze8_45aoWCR3i7HkLP5S0_45oFkMeta } from "/home/les/work/depalop/etmflex/frontend/pages/dashboard/config_log.js?macro=true";
import { default as indexBWJ6KEhkN6K0muY7ntH5qwaZDYCKEGZjj7YXd7CEDJIMeta } from "/home/les/work/depalop/etmflex/frontend/pages/organizations/index.vue?macro=true";
import { default as control_45centergD6g2dLgMQCBmdnxEb27m_j5_bJ8sl8bPQie5xRco9wMeta } from "/home/les/work/depalop/etmflex/frontend/pages/admin/control-center.vue?macro=true";
import { default as _91_91node_id_93_93mZoG23WMjZoNS9QjZwJccXjB_455aH7ZtkEUo0wXupNTsMeta } from "/home/les/work/depalop/etmflex/frontend/pages/explorer/[[node_id]].vue?macro=true";
import { default as config_accountwdDLvt_45KZCwdNUGju3rQIjpf4_45aBr3oGbTDqRLXAhdsMeta } from "/home/les/work/depalop/etmflex/frontend/pages/example/config_account.js?macro=true";
import { default as indexD2DbQK_45jqjsnniwDz_t_45Rj3yz7Ftr3I5geeGM6DHxAAMeta } from "/home/les/work/depalop/etmflex/frontend/pages/milestone_setup/index.vue?macro=true";
import { default as index0g9SBRMqANuJtp4wnixi5x0rjxEfMTkL68klh0qWIUUMeta } from "/home/les/work/depalop/etmflex/frontend/pages/tree_permission/index.vue?macro=true";
import { default as config_accountZE9UVQwX9KuUshIHEqSagWsKIaf2d5xFKmJZKUp_Jf8Meta } from "/home/les/work/depalop/etmflex/frontend/pages/accounts/config_account.js?macro=true";
import { default as config_accountZvjtmrbal80xAfi_45S3Jp25tqTZ6QP2Hvu3iEdY8amNkMeta } from "/home/les/work/depalop/etmflex/frontend/pages/example2/config_account.js?macro=true";
import { default as config_data_dictionary6fQ4zhswQsXEaLPjTwtH_45lX7pF9JmXU0YM_KiKXFXBAMeta } from "/home/les/work/depalop/etmflex/frontend/pages/dd/config_data_dictionary.js?macro=true";
import { default as config_personnel1PbZlhWccnqiwDEFYjwoiftP_45CyKYJwafnvjwtUwED8Meta } from "/home/les/work/depalop/etmflex/frontend/pages/personnel/config_personnel.js?macro=true";
import { default as indexXd1hjNJIXOw7hY76I6HoXJvsavyxScVwS_hW1DAbVskMeta } from "/home/les/work/depalop/etmflex/frontend/pages/protocol_has_account/index.vue?macro=true";
import { default as config_study_role_45I7l_TVpLM1x4W4_45AAiZQjHeqQPIiW3zjzHuorKgX6YMeta } from "/home/les/work/depalop/etmflex/frontend/pages/study_role/config_study_role.js?macro=true";
import { default as indexJKry3M25b_qo1_XX3eQa3c_nDhC2sE3Nwu_x8D9zXJQMeta } from "/home/les/work/depalop/etmflex/frontend/pages/protocol_has_personnel/index.vue?macro=true";
import { default as index6MY0SsvmedaEnh8S8oj2uA1DD38ucnJUd9bE6ScTIp4Meta } from "/home/les/work/depalop/etmflex/frontend/pages/protocol_has_organization/index.vue?macro=true";
import { default as config_organization5YMsWjNkzb9TS9QKCdab9j1bt3qu9Fn9JHQWLZcsu7MMeta } from "/home/les/work/depalop/etmflex/frontend/pages/organizations/config_organization.js?macro=true";
import { default as indexyE_45VBef2qtc2By_5WIkHT_QQpRoX8TWkeugatbLYlOAMeta } from "/home/les/work/depalop/etmflex/frontend/pages/protocol_has_account_has_organization/index.vue?macro=true";
import { default as config_protocol_has_account4UNy1ghY3pJdqVhAo_cYQiARZhZ7t4uVnFxIHvrkksMMeta } from "/home/les/work/depalop/etmflex/frontend/pages/protocol_has_account/config_protocol_has_account.js?macro=true";
import { default as config_protocol_has_personnelWDA4CxVsIc8GLZh0w9riEoXwQUX4MrBmaxEcIEgnYQwMeta } from "/home/les/work/depalop/etmflex/frontend/pages/protocol_has_personnel/config_protocol_has_personnel.js?macro=true";
import { default as config_protocol_has_organizationWA4TmNizNVxUi3U3i_0Qm5neSHMDa4ce0mAZLCwmU2EMeta } from "/home/les/work/depalop/etmflex/frontend/pages/protocol_has_organization/config_protocol_has_organization.js?macro=true";
import { default as config_protocol_has_account_has_organizationGGm0RJn2RiwIQsCxfAxQSGsp4xKKdBccrn_45gMv4ClPYMeta } from "/home/les/work/depalop/etmflex/frontend/pages/protocol_has_account_has_organization/config_protocol_has_account_has_organization.js?macro=true";
export default [
  {
    name: "login",
    path: "/login",
    meta: login6DbUp_45Hrg_FMVyeXHALSCv2gNFi7D1ETVaAscmBybDsMeta || {},
    component: () => import("/home/les/work/depalop/etmflex/frontend/pages/login.vue")
  },
  {
    name: "data_dictionary",
    path: "/dd",
    meta: indexVXLY_452BysBEc8hSz1Ejztqaor9A45CLMd95lffRHAx0Meta || {},
    component: () => import("/home/les/work/depalop/etmflex/frontend/pages/dd/index.vue")
  },
  {
    name: "treatment",
    path: "/ip",
    meta: indexIrTiYQc2LOWmNvug7vKFVxXgGlFfYh0cJjZtNuUBj20Meta || {},
    component: () => import("/home/les/work/depalop/etmflex/frontend/pages/ip/index.vue")
  },
  {
    name: "report-data",
    path: "/report/data",
    component: () => import("/home/les/work/depalop/etmflex/frontend/pages/report/data.js")
  },
  {
    name: "reset-pass",
    path: "/reset-pass",
    meta: reset_45pass9yPl2xoH5S33jAZuqlcS0VK0_WwE6nc2g6k5jRBZ_pIMeta || {},
    component: () => import("/home/les/work/depalop/etmflex/frontend/pages/reset-pass.vue")
  },
  {
    name: "site",
    path: "/site",
    component: () => import("/home/les/work/depalop/etmflex/frontend/pages/site/index.vue")
  },
  {
    name: "task",
    path: "/task",
    meta: indexNkr1UqYOJ__45INI7yaiR4830jFt2pnm8d_K0tzR378xkMeta || {},
    component: () => import("/home/les/work/depalop/etmflex/frontend/pages/task/index.vue")
  },
  {
    name: "pending-data",
    path: "/pending/data",
    component: () => import("/home/les/work/depalop/etmflex/frontend/pages/pending/data.js")
  },
  {
    name: "explorer-data",
    path: "/explorer/data",
    component: () => import("/home/les/work/depalop/etmflex/frontend/pages/explorer/data.js")
  },
  {
    name: "metric",
    path: "/metric",
    component: () => import("/home/les/work/depalop/etmflex/frontend/pages/metric/index.vue")
  },
  {
    name: "report",
    path: "/report",
    meta: indexa7QbScC04ug0Giyt3PRDXjjeNEjmvT7C5_45qrxX_45_45ZD4Meta || {},
    component: () => import("/home/les/work/depalop/etmflex/frontend/pages/report/index.vue")
  },
  {
    name: "example",
    path: "/example",
    component: () => import("/home/les/work/depalop/etmflex/frontend/pages/example/index.vue")
  },
  {
    name: "pending-config",
    path: "/pending/config",
    component: () => import("/home/les/work/depalop/etmflex/frontend/pages/pending/config.js")
  },
  {
    name: "pending",
    path: "/pending",
    component: () => import("/home/les/work/depalop/etmflex/frontend/pages/pending/index.vue")
  },
  {
    name: "protocol_profile",
    path: "/profile",
    meta: indexDiyew2Nk_45dy14guSWWpRxRxEBs35RviaUXB9ia7GBZQMeta || {},
    component: () => import("/home/les/work/depalop/etmflex/frontend/pages/profile/index.vue")
  },
  {
    name: "accounts",
    path: "/accounts",
    component: () => import("/home/les/work/depalop/etmflex/frontend/pages/accounts/index.vue")
  },
  {
    name: "example2",
    path: "/example2",
    component: () => import("/home/les/work/depalop/etmflex/frontend/pages/example2/index.vue")
  },
  {
    name: "testflex",
    path: "/testflex",
    component: () => import("/home/les/work/depalop/etmflex/frontend/pages/testflex/index.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    component: () => import("/home/les/work/depalop/etmflex/frontend/pages/dashboard/index.vue")
  },
  {
    name: "personnel",
    path: "/personnel",
    component: () => import("/home/les/work/depalop/etmflex/frontend/pages/personnel/index.vue")
  },
  {
    name: "protocols",
    path: "/protocols",
    component: () => import("/home/les/work/depalop/etmflex/frontend/pages/protocols/index.vue")
  },
  {
    name: "site-config_site",
    path: "/site/config_site",
    component: () => import("/home/les/work/depalop/etmflex/frontend/pages/site/config_site.js")
  },
  {
    name: "task-config_task",
    path: "/task/config_task",
    component: () => import("/home/les/work/depalop/etmflex/frontend/pages/task/config_task.js")
  },
  {
    name: "acl_permission",
    path: "/permission",
    meta: indexY4CwEHWa5EF0r3EmvG6NcZjNewt2r4hXECanma6V2hQMeta || {},
    component: () => import("/home/les/work/depalop/etmflex/frontend/pages/permission/index.vue")
  },
  {
    name: "study_role",
    path: "/study_role",
    component: () => import("/home/les/work/depalop/etmflex/frontend/pages/study_role/index.vue")
  },
  {
    name: "confirm-reset-pass",
    path: "/confirm-reset-pass",
    meta: confirm_45reset_45passHg__1KjK60_dIYwLMowlainlGfzvA4xYEx0gOc258vEMeta || {},
    component: () => import("/home/les/work/depalop/etmflex/frontend/pages/confirm-reset-pass.vue")
  },
  {
    name: "ip-config_treatment",
    path: "/ip/config_treatment",
    component: () => import("/home/les/work/depalop/etmflex/frontend/pages/ip/config_treatment.js")
  },
  {
    name: "dashboard-config_log",
    path: "/dashboard/config_log",
    component: () => import("/home/les/work/depalop/etmflex/frontend/pages/dashboard/config_log.js")
  },
  {
    name: "organizations",
    path: "/organizations",
    component: () => import("/home/les/work/depalop/etmflex/frontend/pages/organizations/index.vue")
  },
  {
    name: "admin-control-center",
    path: "/admin/control-center",
    component: () => import("/home/les/work/depalop/etmflex/frontend/pages/admin/control-center.vue")
  },
  {
    name: "explorer",
    path: "/explorer/:node_id?",
    meta: _91_91node_id_93_93mZoG23WMjZoNS9QjZwJccXjB_455aH7ZtkEUo0wXupNTsMeta || {},
    component: () => import("/home/les/work/depalop/etmflex/frontend/pages/explorer/[[node_id]].vue")
  },
  {
    name: "example-config_account",
    path: "/example/config_account",
    component: () => import("/home/les/work/depalop/etmflex/frontend/pages/example/config_account.js")
  },
  {
    name: "milestone_setup",
    path: "/milestone_setup",
    meta: indexD2DbQK_45jqjsnniwDz_t_45Rj3yz7Ftr3I5geeGM6DHxAAMeta || {},
    component: () => import("/home/les/work/depalop/etmflex/frontend/pages/milestone_setup/index.vue")
  },
  {
    name: "tree_permission",
    path: "/tree_permission",
    meta: index0g9SBRMqANuJtp4wnixi5x0rjxEfMTkL68klh0qWIUUMeta || {},
    component: () => import("/home/les/work/depalop/etmflex/frontend/pages/tree_permission/index.vue")
  },
  {
    name: "accounts-config_account",
    path: "/accounts/config_account",
    component: () => import("/home/les/work/depalop/etmflex/frontend/pages/accounts/config_account.js")
  },
  {
    name: "example2-config_account",
    path: "/example2/config_account",
    component: () => import("/home/les/work/depalop/etmflex/frontend/pages/example2/config_account.js")
  },
  {
    name: "dd-config_data_dictionary",
    path: "/dd/config_data_dictionary",
    component: () => import("/home/les/work/depalop/etmflex/frontend/pages/dd/config_data_dictionary.js")
  },
  {
    name: "personnel-config_personnel",
    path: "/personnel/config_personnel",
    component: () => import("/home/les/work/depalop/etmflex/frontend/pages/personnel/config_personnel.js")
  },
  {
    name: "protocol_has_account",
    path: "/protocol_has_account",
    meta: indexXd1hjNJIXOw7hY76I6HoXJvsavyxScVwS_hW1DAbVskMeta || {},
    component: () => import("/home/les/work/depalop/etmflex/frontend/pages/protocol_has_account/index.vue")
  },
  {
    name: "study_role-config_study_role",
    path: "/study_role/config_study_role",
    component: () => import("/home/les/work/depalop/etmflex/frontend/pages/study_role/config_study_role.js")
  },
  {
    name: "protocol_has_personnel",
    path: "/protocol_has_personnel",
    meta: indexJKry3M25b_qo1_XX3eQa3c_nDhC2sE3Nwu_x8D9zXJQMeta || {},
    component: () => import("/home/les/work/depalop/etmflex/frontend/pages/protocol_has_personnel/index.vue")
  },
  {
    name: "protocol_has_organization",
    path: "/protocol_has_organization",
    meta: index6MY0SsvmedaEnh8S8oj2uA1DD38ucnJUd9bE6ScTIp4Meta || {},
    component: () => import("/home/les/work/depalop/etmflex/frontend/pages/protocol_has_organization/index.vue")
  },
  {
    name: "organizations-config_organization",
    path: "/organizations/config_organization",
    component: () => import("/home/les/work/depalop/etmflex/frontend/pages/organizations/config_organization.js")
  },
  {
    name: "protocol_has_account_has_organization",
    path: "/protocol_has_account_has_organization",
    meta: indexyE_45VBef2qtc2By_5WIkHT_QQpRoX8TWkeugatbLYlOAMeta || {},
    component: () => import("/home/les/work/depalop/etmflex/frontend/pages/protocol_has_account_has_organization/index.vue")
  },
  {
    name: "protocol_has_account-config_protocol_has_account",
    path: "/protocol_has_account/config_protocol_has_account",
    component: () => import("/home/les/work/depalop/etmflex/frontend/pages/protocol_has_account/config_protocol_has_account.js")
  },
  {
    name: "protocol_has_personnel-config_protocol_has_personnel",
    path: "/protocol_has_personnel/config_protocol_has_personnel",
    component: () => import("/home/les/work/depalop/etmflex/frontend/pages/protocol_has_personnel/config_protocol_has_personnel.js")
  },
  {
    name: "protocol_has_organization-config_protocol_has_organization",
    path: "/protocol_has_organization/config_protocol_has_organization",
    component: () => import("/home/les/work/depalop/etmflex/frontend/pages/protocol_has_organization/config_protocol_has_organization.js")
  },
  {
    name: "protocol_has_account_has_organization-config_protocol_has_account_has_organization",
    path: "/protocol_has_account_has_organization/config_protocol_has_account_has_organization",
    component: () => import("/home/les/work/depalop/etmflex/frontend/pages/protocol_has_account_has_organization/config_protocol_has_account_has_organization.js")
  }
]